<template>
  <div>
    <v-switch v-model="enabled" :label="schema.labelSwitch" dense hide-details @change="toggleAttributesInfo" class="my-2" />

    <DevContainerOfPanel
      v-if="enabled"
      :schema="{
        type: 'devContainerOfPanel',
        model: schema.model,
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: schema.labelContainer
      }"
      :model="{ [schema.model]: model[schema.model] }"
    />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField],

  components: {
    DevContainerOfPanel: () => import('@/components/dev/dev-container-of-panel')
  },

  data: () => ({
    enabled: false,
    attributesObj: {}
  }),

  mounted() {
    this.changeEnabled();

    this.attributesObj = this.schema.obj;
  },

  methods: {
    toggleAttributesInfo(e) {
      if (e) this.model[this.schema.model] = this.attributesObj;

      if (!e) delete this.model[this.schema.model];

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    changeEnabled() {
      this.schema.model in this.model ? (this.enabled = true) : (this.enabled = false);
    }
  },

  watch: {
    model(newValue) {
      this.changeEnabled();
    }
  }
};
</script>
